import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from '../../storageprovider';
import { Utility } from '../utility';

@Injectable({
    providedIn: 'root'
})
export class GuideService {
    private guideCoverSource = new BehaviorSubject<any>(false);
    guideCover = this.guideCoverSource.asObservable();

    private showColorGuide = new BehaviorSubject<any>(false);
    colorGuide = this.showColorGuide.asObservable();

    private showSettingGuide = new BehaviorSubject<any>(false);
    settingGuide = this.showSettingGuide.asObservable();

    cookies = {
        colorGuide: true,
        settingGuide: true,
    };

    isBot = false;

    stopGuide = true;
    constructor(
        private _utility:Utility,
        private _storage:StorageService
    ) {

        this.isBot = this._utility.isBot();

    }

    closeGuideCover(isPlayerPage, type) {
        switch (type) {
            case 'color':
                this.showColorGuide.next(false);
                break;
            case 'setting':
                this.showSettingGuide.next(false);
                break;
            case 'all':
                this.showSettingGuide.next(false);
                this.showColorGuide.next(false);
                break;
        }
        this.coverStateByPage(isPlayerPage ? 'player' : 'ohter');
    }

    coverStateByPage(page) {
        if (page === 'player') {
            let showColor = false;
            this.colorGuide.subscribe(r => {
                showColor = r;
            });
            let showSetting = false;
            this.settingGuide.subscribe(r => {
                showSetting = r;
            });
            const state = showColor || showSetting;
            this.guideCoverSource.next(state);
        } else {
            this.guideCoverSource.next(false);
        }
    }

    getGuideCookie(type) {

        if (this.stopGuide) {
            // 不启用引导
            return;
        }

        if (!this.isBot) {
            // type: 0 播放设置; 1 换肤设置
            const guideCookie =   JSON.parse(this._storage.GetCookie("web_guide") || '{}');//this.stringToJSON(this.getCookie('web_guide'));
            if (guideCookie.settingGuide === undefined) {
                this._storage.SetCookie(
                    'web_guide',
                    this.cookies,
                    365
                );
                this.showColorGuide.next(true);
                this.showSettingGuide.next(true);
                this.guideCoverSource.next(true);
            } else {
                this.cookies = guideCookie;
                switch (type) {
                    case 0:
                        this.showSettingGuide.next(guideCookie.settingGuide);
                        this.coverStateByPage('player');
                        break;
                    case 1:
                        this.showColorGuide.next(guideCookie.colorGuide);
                        this.guideCoverSource.next(guideCookie.colorGuide);
                        break;
                }
            }
        }



    }

    setGuideCookie(type) {


        // type: 0 播放设置; 1 换肤设置
        let cookieObj;
        switch (type) {
            case 0:
                cookieObj = Object.assign(
                    this.cookies,
                    { settingGuide: false }
                );
                this.showSettingGuide.next(false);
                break;
            case 1:
                cookieObj = Object.assign(
                    this.cookies,
                    { colorGuide: false }
                );
                this.showColorGuide.next(false);
                break;
        }
        this.cookies = cookieObj;
        this._storage.SetCookie(
            'web_guide',
            cookieObj,
            365
        );
    }

    // setCookie(name, value, days) {
    //     var expires = "";
    //     if (days) {
    //         var date = new Date();
    //         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    //         expires = "; expires=" + date.toUTCString();
    //     }
    //     var host = this._utility.GetHost("", true);
    //     var domain = "domain=" + (host && host.indexOf(".") == 0 ? host : "." + host);
    //     document.cookie = name + "=" + (value || "") + expires + "; path=/;" + domain;
    // }

    // getCookie(name) {
    //     const value = `; ${document.cookie}`;
    //     const parts = value.split(`; ${name}=`);
    //     if (parts.length === 2) return parts.pop().split(';').shift();
    // }

    stringToJSON(string) {
        if (!!string) {
            return JSON.parse(string);
        } else {
            return;
        }
    }
}
